import {
  SUREST_RELATIVE_COST_DRIVERS_SUCCESS,
  SUREST_RELATIVE_COST_DRIVERS_REQUEST,
  SUREST_RELATIVE_COST_DRIVERS_FAILURE,
  SUREST_RELATIVE_DISTRIBUTION_SUCCESS,
  SUREST_RELATIVE_DISTRIBUTION_REQUEST,
  SUREST_RELATIVE_DISTRIBUTION_FAILURE,
  SUREST_RELATIVE_COMMON_SERVICES_REQUEST,
  SUREST_RELATIVE_COMMON_SERVICES_SUCCESS,
  SUREST_RELATIVE_COMMON_SERVICES_FAILURE,
} from '@src/middleware/actions/actionTypes';

export const setRelativeCostDriverData = (payload: unknown) => ({
  type: SUREST_RELATIVE_COST_DRIVERS_SUCCESS,
  payload,
});

export const setRelativeCostDriverRequest = (payload: unknown) => ({
  type: SUREST_RELATIVE_COST_DRIVERS_REQUEST,
  payload,
});

export const setRelativeCostDriverError = (payload: unknown) => ({
  type: SUREST_RELATIVE_COST_DRIVERS_FAILURE,
  payload,
});

export const setRelativeDistributionData = (payload: unknown) => ({
  type: SUREST_RELATIVE_DISTRIBUTION_SUCCESS,
  payload,
});
export const setRelativeDistributionRequest = (payload: unknown) => ({
  type: SUREST_RELATIVE_DISTRIBUTION_REQUEST,
  payload,
});

export const setRelativeDistributionError = (payload: unknown) => ({
  type: SUREST_RELATIVE_DISTRIBUTION_FAILURE,
  payload,
});

export const setRelativeCommonServicesRequest = (payload: unknown) => ({
  type: SUREST_RELATIVE_COMMON_SERVICES_REQUEST,
  payload,
});

export const setRelativeCommonServicesData = (payload: unknown) => ({
  type: SUREST_RELATIVE_COMMON_SERVICES_SUCCESS,
  payload,
});

export const setRelativeCommonServicesError = (payload: unknown) => ({
  type: SUREST_RELATIVE_COMMON_SERVICES_FAILURE,
  payload,
});
